import $ from 'jquery';
import './bird-tout.scss';

class BirdTout {
  constructor(element) {
    this.element = element;
    this._update = this._update.bind(this);
    $(this.element).on('instagramfeednewcontent', this._update);
  }

  _update() {
  }

  /**
  * Initialize every module of this kind on the page.
  * @return {Array.<BirdTout>}
  */
  static initializeAll() {
    return $('.bird-tout').map((i, el) => new BirdTout(el)).get();
  }
}

export default BirdTout;
